module.exports = __webpack_public_path__ + "img/invite_img.4e0ca6b6.png";